<template>
  <div class="d-contents">
    <DefaultButton class="text__size-12 ma-1" @doFunction="handleOpenFileUpload()" height="auto" :disabled="disabled">
      <div class="btn-group__text">
          <span v-if="name">{{ name }}</span>
          <span v-if="enName">{{ enName }}</span>
      </div>
    </DefaultButton>
    <ScrollableDialog dialogTitle="附件上傳／查詢作業 Upload Attachment / Query" v-model="handleOpen" width="95%">
      <v-card-text>
        <div>
          <span class="red--text">注意事項：</span>
          <span class="red--text text--darken-4">目前server可判別有word、excel、pdf、txt、rar、zip、bmp、ppt和jpg檔，上傳文件時請先確定清楚檔案格式
            Precaution: The server would differentiate: Word, excel, pdf, txt, rar, zip, bmp, ppt and jpg files. Please make sure the file format before uploading.
          </span>
        </div>

        <SearchBox labeltxt="檔案 File" class="my-2">
          <DefaultButton :colorType="'primary'" class="mr-2 mb-2 text__size-14" @doFunction="toggleFileUpload">
            <v-icon class="cus-Btn__primary__addIconHover">mdi-plus</v-icon>
            <span>選擇檔案</span>
          </DefaultButton>
          {{selectedFile == null ? null : selectedFile.name}}
          <input type="file" ref="uploader" class="d-none" @change="onFileChanged" />
        </SearchBox>
        <DefaultTextarea labeltxt="備註 Notes" v-model="notes"></DefaultTextarea>

        <FormFooter>
          <DefaultButton class="text__size-14" @doFunction="toggleFileCreate" height="auto" :disabled="disabledFileUpload">
            <div class="btn-group__text">
              <span>檔案上傳</span>
              <span>Upload</span>
            </div>
          </DefaultButton>
          <DefaultButton class="text__size-14" @doFunction="handleOpen = false" height="auto">
            <div class="btn-group__text">
              <span>關閉視窗</span>
              <span>Close</span>
            </div>
          </DefaultButton>
        </FormFooter>
        <DefaultTable :headers="fileHeaders" :table="fileList">
          <template slot="doc_name" slot-scope="item">
            <a @click="toggleFileOpen(item.item)">{{ item.item.doc_name }}</a>
          </template>
          <template slot="fileHandler" slot-scope="item">
            <div class="handler-group">
              <DefaultButton :colorType="'delete'" class="text__size-14" @doFunction="toggleFileDel(item.item)" height="auto" v-if="item.item.ls_file_del_YN == 'Y'">
                <div class="btn-group__text">
                  <span>刪除</span>
                  <span>Delete</span>
                </div>
              </DefaultButton>
            </div>
          </template>
        </DefaultTable>
      </v-card-text>
    </ScrollableDialog>
  </div>
</template>

<script>

export default {
  name: 'FileUploadButton',
  props: {
    name: {
      type: String,
      default: '附件上傳',
    },
    enName: {
      type: String,
      default: 'Upload',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabledFileUpload: {
      type: Boolean,
      required: false,
      default: false,
    },
    fileUploadId: {
      type: String,
    },
    fileUploadType: {
      type: String,
    },
  },
  data() {
    return {
      handleOpen: false,
      selectedFile: null,
      leaveTranBarcode: null,
      notes: '',
      fileList: [],
      fileHeaders: [
        { text: '序', value: 'index', align: 'center' },
        { text: '文件名稱', value: 'doc_name', align: 'center' },
        { text: '備註', value: 'doc_desc', align: 'center' },
        { text: '功能', value: 'fileHandler', align: 'center' },
      ],
    };
  },
  methods: {
    /* 附件上傳 / 查詢作業 Start */
    doLoadLeaveAttachmentViewData() {
      // 請假附件上傳
      const params = {
        li_pub_key: 0,
        LeaveTranBarcode: this.fileUploadId,
      };
      return new Promise((reslove) => {
        $api.s41.S41W2001_LeaveAttachmentViewLoad(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.fileList = data;
            this.notes = '';
            reslove(data);
          }
        });
      });
    },
    handleUploaderClear() {
      this.$refs.uploader.value = null;
      this.selectedFile = null;
    },
    handleOpenFileUpload() {
      if (this.fileUploadType === 'leave') {
        this.doLoadLeaveAttachmentViewData().then(() => {
          this.handleOpen = true;
          this.selectedFile = null;
        });
      } else if (this.fileUploadType === 'other') {
        // 其他上傳類別
      }
    },
    toggleFileCreate() {
      if (this.selectedFile === null) {
        this.$swal
          .fire({
            title: '請選擇檔案！',
            icon: 'warning',
            titleColor: '#FB966E',
            confirmButtonText: '確定',
            confirmButtonColor: '#FB966E',
          });

        return;
      }

      if (this.fileUploadType === 'leave') {
        const formData = new FormData();
        formData.append('UploadFile', this.selectedFile);
        formData.append('leaveTranBarcode', this.fileUploadId);
        formData.append('notes', this.notes);

        $api.s41.S41W2001_LeaveAttachmentViewFileUpload(formData).then((res) => {
          const { code, result } = res;
          if (code === 200) {
            if (result.success === true) {
              this.doLoadLeaveAttachmentViewData().then(() => {
                this.$swal.fire({
                  icon: 'success',
                  title: '附件上傳成功！',
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.handleUploaderClear();
              });
            }
          }
        });
      } else if (this.fileUploadType === 'other') {
        // 其他上傳類別
      }
    },
    toggleFileUpload() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      if (e.target.files[0] === undefined) return;

      const file = e.target.files[0];
      const { type, size } = file;

      if (type.match('image/jpeg')
      || type.match('image/bmp')
      || type.match('application/pdf')
      || type.match('text/plain')
      || type.match('application/zip')
      || type.match('application/x-zip-compressed')
      || type.match('application/vnd.rar')
      || type.match('application/vnd.ms-powerpoint')
      || type.match('application/vnd.openxmlformats-officedocument.presentationml.presentation')
      || type.match('application/msword')
      || type.match('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
      || type.match('application/vnd.ms-excel')
      || type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        if (size <= 5 * 1024 * 1024) {
          this.selectedFile = file;
        } else {
          this.$swal.fire({
            icon: 'error',
            title: '上傳大小不可大於5MB！',
          });
          this.handleUploaderClear();
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: '上傳格式錯誤！',
        });
        this.handleUploaderClear();
      }
    },
    toggleFileOpen(item) {
      window.open(`${process.env.VUE_APP_BASE_URL}${item.doc_url}`, '_blank');
    },
    toggleFileDel(item) {
      this.$swal
        .fire({
          title: '確定要刪除嗎？',
          icon: 'warning',
          showCancelButton: true,
          titleColor: '#FB966E',
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          confirmButtonColor: '#FB966E',
          cancelButtonColor: 'gray',
        })
        .then((r) => {
          if (r.isConfirmed) {
            if (this.fileUploadType === 'leave') {
              const params = {
                li_pub_key: 0,
                LeaveTranBarcode: this.fileUploadId,
                FileId: item.doc_id,
              };

              $api.s41.S41W2001_LeaveAttachmentViewFileDelete(params).then((res) => {
                const { code, result } = res;
                if (code === 200 && result.success === true) {
                  this.doLoadLeaveAttachmentViewData().then(() => {
                    this.$swal.fire({
                      title: '刪除成功!',
                      icon: 'success',
                      iconColor: '#FB966E',
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  });
                }
              });
            } else if (this.fileUploadType === 'other') {
              // 其他上傳類別
            }
          }
        });
    },
    /* 附件上傳 / 查詢作業 End */
  },
};
</script>

<style lang="scss" scoped>

.d-contents {
  display: contents;
}
</style>
